(function () {
  /**
   * @param {HTMLElement} root
   */
  function initTabs(root) {
    if (!(root instanceof HTMLElement) || root.dataset.tabsInitialized === 'true') return;

    const buttons = root.querySelectorAll('[data-custom-product-tab]');
    const panels = root.querySelectorAll('[data-custom-product-panel]');

    if (!buttons.length || !panels.length) return;

    root.dataset.tabsInitialized = 'true';

    /**
     * @param {HTMLElement} button
     */
    function activateTab(button) {
      if (!(button instanceof HTMLElement)) return;

      const target = button.getAttribute('data-custom-product-tab');
      if (!target) return;

      buttons.forEach((item) => {
        if (!(item instanceof HTMLElement)) return;

        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        if (!(panel instanceof HTMLElement)) return;

        const isActive = panel.getAttribute('data-custom-product-panel') === target;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    buttons.forEach((button) => {
      if (!(button instanceof HTMLElement)) return;

      button.addEventListener('click', () => {
        activateTab(button);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-product-tabs]').forEach((tabs) => {
      if (tabs instanceof HTMLElement) {
        initTabs(tabs);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    target.querySelectorAll('[data-custom-product-tabs]').forEach((tabs) => {
      if (!(tabs instanceof HTMLElement)) return;

      delete tabs.dataset.tabsInitialized;
      initTabs(tabs);
    });
  });
})();
